// -------- Welcome Page --------
export const WELCOME_HEADER = "Welcome!"
export const WELCOME_MESSAGE_1 = "Spectrum Interactive is an event lighting and software development " +
    "company offering contracting and consulting services. We are proud to serve the Denver Metro Area with:"

export const WELCOME_OPTIONS = [
    "Lighting / visualization for live events and video production",
    "Custom software development and consulting services",
]

export const WELCOME_MESSAGE_2 = "Want to get in touch? We would love to hear from you!"

export const LIGHTING_HEADER = "Lighting"
export const LIGHTING_MESSAGE = "Lighting is a powerful tool for creating atmosphere and mood for your event. " +
    "We use in-house lighting control software customized for your event to create a unique experience for your audience. "

export const SOFTWARE_HEADER = "Software"
export const SOFTWARE_MESSAGE = "Let us put our 7+ years of full stack software development experience to work " +
    "for you. We specialize in web and desktop applications using Python and React, but will work with you to choose the " +
    "right stack for your project."


// -------- Lighting Page --------
export const LIGHTING_PAGE_TITLE = "Spectrum Interactive Lighting"
export const LIGHTING_PAGE_DESCRIPTION = "We use our in-house software to create an experience unique to " +
    "your music, event, and location. Work with us to build your own color palettes, queues, and effects. Now serving " +
    "bands, DJs, venues, and producers in the Denver Metro Area."

export const SILI_DESCRIPTION_1 = "The spectrum interactive lighting instrument is our diverse in-house tool for lighting " +
    "control and visualization. SILI is a desktop application that allows configuration and real-time control of DMX " +
    "lighting fixtures."
export const SILI_FEATURES = [
    "Easily configurable for a wide variety of DMX lighting fixtures",
    "Includes interactive visualizer supporting any HDMI display",
    "Compatible with any bluetooth gaming controller for remote control",
]

export const SILI_DESCRIPTION_2 = "Below you can find examples of SILI in action."

export const VIDEO_LINKS = [
    "https://www.youtube.com/embed/62HgKCfD6ZU?si=EUowFFFR1fJzYKVT",
    "https://www.youtube.com/embed/mq03eG8tv18?si=U4RAiIF9CwkmoklG"
]


// -------- Software Page --------
export const SOFTWARE_PAGE_TITLE = "Software Services"
export const SOFTWARE_PAGE_DESCRIPTION_1 =  "We will work closely with you to understand your specific needs " +
    "and challenges, and collaborate with you to determine the best solution for you or your business. "
export const SOFTWARE_PAGE_DESCRIPTION_2 = "Whether it's an off-the-shelf product or a custom built system, we'll " +
    "ensure that it's cost effective and delivers the highest possible value. We specialize in:"
export const SOFTWARE_SERVICES_LIST = [
    "Full-stack cloud-based web applications",
    "Desktop Applications",
    "Control, Automation, and Testing"
]
